var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevportalCloudUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "devportal-cloud-upload_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#devportal-cloud-upload_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.417 16.25c-1.153 0-2.136-.4-2.949-1.198-.812-.799-1.218-1.774-1.218-2.927 0-1.042.333-1.955 1-2.74C2.917 8.601 3.743 8.139 4.73 8c.263-1.25.888-2.27 1.874-3.063A5.272 5.272 0 0110 3.75c1.514 0 2.795.524 3.844 1.572 1.049 1.05 1.573 2.33 1.573 3.845v.416h.25c.889.07 1.625.424 2.208 1.063.583.639.875 1.396.875 2.27 0 .931-.32 1.72-.958 2.365-.64.646-1.424.969-2.355.969h-4.562c-.417 0-.77-.146-1.063-.438a1.447 1.447 0 01-.437-1.062v-4.604L8.271 11.27a.592.592 0 01-.438.166.592.592 0 01-.614-.614.613.613 0 01.177-.427l2.083-2.084a.504.504 0 01.24-.166.947.947 0 01.563 0c.09.028.17.083.239.166l2.083 2.084c.111.11.17.253.178.426a.592.592 0 01-.615.615.557.557 0 01-.438-.187l-1.104-1.104v4.604c0 .056.028.111.083.167.056.055.111.083.167.083h4.542c.583 0 1.076-.201 1.479-.604.403-.403.604-.896.604-1.48 0-.583-.201-1.076-.604-1.479a2.011 2.011 0 00-1.48-.604h-1.25V9.167c0-1.153-.405-2.136-1.218-2.949C12.136 5.406 11.153 5 10 5s-2.135.406-2.947 1.218c-.813.813-1.22 1.796-1.22 2.949h-.437c-.792 0-1.472.284-2.042.854a2.81 2.81 0 00-.854 2.062c0 .806.285 1.493.854 2.063A2.81 2.81 0 005.417 15h1.458c.18 0 .33.059.448.177a.609.609 0 01.177.448c0 .18-.059.33-.177.448a.61.61 0 01-.448.177H5.417z",
    fill: "#fff"
  }))));
}
export default __webpack_public_path__ + "assets/static/media/devportal-cloud-upload.de055c2e.svg";
export { SvgDevportalCloudUpload as ReactComponent };